import ResultTable from "../Table/ResultTable";
import ResultHeader from "../Table/ResultHeader";
import ResultRow from "../Table/ResultRow";
import ResultHeaderCell from "../Table/ResultHeaderCell";
import HecRasHelper from "../../Helpers/HecRasHelper";
import ResultBody from "../Table/ResultBody";
import ResultBodyCell from "../Table/ResultBodyCell";

export default function FlowChangeTable({data, profiles, selectedCS}) {

    return (
        <ResultTable maxWidth={HecRasHelper.getWidth(5 + 12 + (profiles?.length*10))}>
            <ResultHeader>
                <ResultRow>
                    <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(5)}}>#</ResultHeaderCell>
                    <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>RS</ResultHeaderCell>
                    {
                        profiles.map(p => (
                            <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                {p}
                            </ResultHeaderCell>
                        ))
                    }
                </ResultRow>
            </ResultHeader>
            <ResultBody>
                {
                    data?.map((row, idx) => {
                        return (
                            <ResultRow style={{fontWeight: selectedCS === row?.cross_section ? 'bold' : ''}}>
                                <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(5)}}>{idx+1}</ResultBodyCell>
                                <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>{row?.cross_section}</ResultBodyCell>
                                {
                                    row?.flow_locations?.map(fl => (
                                        <ResultBodyCell style={{textAlign: 'right', width: HecRasHelper.getWidth(10)}}>
                                            {fl}
                                        </ResultBodyCell>
                                    ))
                                }
                            </ResultRow>
                        )
                    })
                }
            </ResultBody>
        </ResultTable>
    )
}